/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module CoreModule
 */

export enum AviModalType {
    AVI_MODAL,
    AVI_ALERT_OR_CONFIRM,
}
